import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NotificationService } from 'src/app/_helpers/notification.service';
import { LicensingService } from '../licensing.service';
import { AppSettings } from 'src/app/_helpers/app.settings';
import { UtilitiesService } from 'src/app/utility/utilities.service';
import { HelperService } from 'src/app/_helpers/helper.service';
import { PricingService } from 'src/app/pricing/pricing.service';
import { MatEndDate } from '@angular/material/datepicker';
@Component({
  selector: 'app-create-customer',
  templateUrl: './create-customer.component.html',
  styleUrls: ['./create-customer.component.scss']
})
export class CreateCustomerComponent implements OnInit{
  AppSettings = AppSettings;
  initialData: any = {};
  // code: string = '';
  model: any = {
  };
  licenseList: any = AppSettings.CREATE_LICENSE_TYPE;
  utilityLeftValues: any = [];
  utilityList: any = [];
  utilitiesRightValues: any = [];
  utilityRightList: any = [];
  minDate = new Date();
  licenseDataLoaded: boolean = false;
  utilityDataLoaded: boolean = false;
  priceListLoaded: boolean = false;
  priceList: any = [];
  modulesTobeCharged: any = [];
  instanceType: string = 'CLOUD';
  @Output() updateList = new EventEmitter();

  constructor(
    public modalRef: BsModalRef,
    public notificationService: NotificationService,
    public licensingService: LicensingService,
    public utilityService: UtilitiesService,
    public helper: HelperService,
    public pricingService: PricingService
  ) {

  }
  ngOnInit(): void {
    this.model.licenseType = '';
    this.model.customerCode = this.initialData.customerCode;
    this.setCost();
    if(this.initialData?.isEdit){
      this.fetchLicenseDetail();
    }
    this.loadUtilities();
    this.fetchPricing();
  }
  fetchLicenseDetail() {
    this.helper.showLoader(true);
    this.licenseDataLoaded = false;
    let data = {
      customerCode: this.model.customerCode
    }
    this.licensingService.fetchLicenseDetail({
      data: data,
      success: (response: any) => {
        if(response) {
          let data = response;
          this.model.code = data.customerCode;
          this.model.licenseType = data.isPaidLicense ? "paid" : "trial";
          this.model.scriptedcheck = data.scripted;
          this.model.scriptlesscheck = data.scriptless;
          this.model.randomTestDataCheck = data.randomTDG;
          this.model.designCoPilotCheck = data.designCopilot;
          this.model.selectedUtilities = data.utilities;
          this.model.startDate = data.startDate;
          this.model.endDate = data.endDate;
          this.model.userCount = data.userCount;
          this.model.totalCost = data.totalCost;
          this.model.utilityList = data.utilities;
          this.model.isActive = data.isActive;
          this.licenseDataLoaded = true;
          this.instanceType = data.instanceType;
          this.setUtilities();
        }
      },
      error: (error: any) => {
        console.log(error);
        this.helper.showLoader(false);

      }
    });
  }
  loadUtilities() {
    this.utilityService.fetchAllUtilities({
      success: (response: any) => {
        if(response && response.data) {
          console.log(response.data);
          this.utilityList = response.data;
          this.utilityDataLoaded = true;
          this.setUtilities();
        }
      },
      error: (error: any) => {
        console.log(error);
        this.helper.showLoader(false);

      }
    });
  }
  fetchPricing() {
    this.helper.showLoader(true);
    this.priceListLoaded = false;
    this.pricingService.fetchAllPricingList({
      success: (response: any) => {
        if(response && response.data) {
          this.priceList = response.data;
        }
        this.helper.showLoader(false);
        this.priceListLoaded = true;
        this.setUtilities();
      },
      error: (error: any) => {
        this.priceList = [];
        this.helper.showLoader(false);
      }
    });
  }
  setUtilities() {
    if(this.licenseDataLoaded && this.utilityDataLoaded && this.priceListLoaded) {
      this.utilityRightList = this.model.utilityList;
      let selectedIds = this.utilityRightList.map((sel: any) => sel.id);
      this.utilityList = this.utilityList.filter((rec: any) => selectedIds.indexOf(rec.id) == -1);
      if(this.initialData.isEdit) {
        this.addCostModules();
      }
      this.licenseDataLoaded = false;
      this.utilityDataLoaded = false;
      this.helper.showLoader(false);
    }
  }
  rightAppPressed() {
    if(!this.utilityLeftValues?.length) {
      return;
    }
    let selectedUtilities: any = [];
    let filterObj: any;
    this.utilityList.forEach((selectedValue: any) => {
      filterObj = this.utilityLeftValues.find((obj: any) => { 
        return obj.id == selectedValue.id;
      });
      if(filterObj && Object.keys(filterObj).length) {
        selectedUtilities.push(filterObj.id);
      }
    });
    if(!selectedUtilities?.length) {
      return;
    }
    this.utilityRightList = [...this.utilityRightList, ...this.utilityLeftValues];
    this.utilityList = this.removeElementsFromArray(this.utilityList, selectedUtilities);
    if(this.utilityRightList?.length) {
      this.updateCostModule(AppSettings.COST_MODULE_MAP.UTILITIES);
      this.modulesTobeCharged.push(AppSettings.COST_MODULE_MAP.UTILITIES);
      this.setCost();
    }

  }
  leftAppPressed() {
    if(!this.utilityRightList?.length) {
      return;
    }
    let selectedUtilities: any = [];
    let filterObj: any;
    this.utilityRightList.forEach((selectedValue: any, index: number) => {
      filterObj = this.utilitiesRightValues.find((obj: any) => { 
        return obj.id == selectedValue.id;
      });
      if(filterObj && Object.keys(filterObj).length) {
        selectedUtilities.push(filterObj.id);
      }
    });
    if(!selectedUtilities?.length) {
      return;
    }
    this.utilityList = [...this.utilityList, ...this.utilitiesRightValues];
    this.utilityRightList = this.removeElementsFromArray(this.utilityRightList, selectedUtilities);
    if(this.utilityRightList?.length) {
      this.updateCostModule(AppSettings.COST_MODULE_MAP.UTILITIES);
      this.modulesTobeCharged.push(AppSettings.COST_MODULE_MAP.UTILITIES);
      this.setCost();
    }
    if(!this.utilityRightList?.length) {
      this.updateCostModule(AppSettings.COST_MODULE_MAP.UTILITIES);
      this.setCost();
    }
  }
  removeElementsFromArray(list: any, selectedUtilities: any) {
    if(!list?.length || !selectedUtilities?.length) {
      return;
    }
    let index;
    selectedUtilities.forEach((rec: any) => {
      index = list.findIndex((ele: any) => {
        return ele.id == rec;
      });
      if(index > -1) {
        list.splice(index, 1);
      }
    });
    return list;
  }
  removeSelection() {
    this.utilitiesRightValues = [];
    this.utilityLeftValues = [];

  }
  addCostModules() {
    this.modulesTobeCharged = [];
    if(this.model.scriptedcheck) {
      this.modulesTobeCharged.push(AppSettings.COST_MODULE_MAP['QE360SCRIPTED']);
    }
    if(this.model.scriptlesscheck) {
      this.modulesTobeCharged.push(AppSettings.COST_MODULE_MAP['QE360SCRIPTLESS']);
    }
    if(this.model.randomTestDataCheck) {
      this.modulesTobeCharged.push(AppSettings.COST_MODULE_MAP['RANDOMTESTDATA']);
    }
    if(this.model.designCoPilotCheck) {
      this.modulesTobeCharged.push(AppSettings.COST_MODULE_MAP['DESIGNCOPILOT']);
    }
    if(this.utilityRightList?.length) {
      this.modulesTobeCharged.push(AppSettings.COST_MODULE_MAP.UTILITIES);
    }
    if(this.model.userCount > 0) {
      this.modulesTobeCharged.push(this.helper.getUserPricingKey(this.priceList, this.model.userCount));
    }
    this.setCost();
  }
  isValidatationError() {
    let error = '';
    let regExRes = this.validateString(this.model.code);
    if(!this.model.code?.trim()) {
      error = "Please enter customer code.";
    } else if (!regExRes.status) {
      error = `${regExRes.message} for Customer Code.`;
    }else if(!this.model.licenseType) {
      error = "Please select license type.";
    } else if(!this.model.scriptlesscheck && !this.model.scriptedcheck) { 
      error = "Atleast one option should be selected from QE360 Scriptless and QE360 Scripted."
    } else if(!this.model.startDate) {
      error = "Please select Start Date."
    } else if(!this.model.endDate) {
      error = "Please select End Date."
    } else if(this.helper.convert(this.model.startDate, AppSettings.YYYY_MM_DD) > this.helper.convert(this.model.endDate, AppSettings.YYYY_MM_DD)) {
      error = "Please selct End date which is after Start date."
    }
      else if(!this.model.userCount || this.model.userCount < 1) {
      error = "User count should be atleast 1."
    }
    return error;
  }
  validateString(st: string) {
    if(!st || !st.trim()) {
      return;
    }
    let xssResp: any = {};
    let regex =  /(^[A-Z])+([A-Z_]{3,})+([A-Z_]$)/;
    if (!regex.test(st)) {
      xssResp.status = false;
      xssResp.message = "Min length should be 5, Numbers, Special characters/spaces are not allowed ";
      return xssResp;
    } else {
      xssResp.status = true;
      xssResp.message = "Success";
      return xssResp;
    }
  }
  onCustomerCodeChange(e: any) {
    //if we use uppercase pipe in html, it is giving last char in small case while validating in regex, so we need to manually make them uppsercase
    this.model.code = e?.toUpperCase();
  }
  onUserCountChange(e: any) {
    this.updateCostModule(AppSettings.COST_MODULE_MAP.USERS);
      if(this.model.userCount > 0) {
        this.modulesTobeCharged.push(this.helper.getUserPricingKey(this.priceList, this.model.userCount));
      } 
      this.setCost();
  }
  onCheckboxChange(e: any, module: string) {
    this.updateCostModule(module);
    if(e) { //checked
      this.modulesTobeCharged.push(AppSettings.COST_MODULE_MAP[module]);
    }
    this.changeState();
    this.setCost();
  }
  changeState() {
    if(!this.model.scriptlesscheck) {
      this.model.randomTestDataCheck = false;
      this.model.designCoPilotCheck = false;
    }
  }
  updateCostModule(module: string) {
    let isModulePresent = this.helper.isModulePresent(this.modulesTobeCharged, AppSettings.COST_MODULE_MAP[module]);
    if(isModulePresent) {
      this.helper.removeModule(this.modulesTobeCharged, AppSettings.COST_MODULE_MAP[module]);
    }
  }
  save() {
    let validationError = this.isValidatationError();
    if(validationError) {
      this.notificationService.showError(validationError);
      return;
    }
    this.helper.showLoader(true);
    let data: any = {
      "customerCode": this.model.code,
      "userCount": this.model.userCount,
      "startDate": this.helper.convert(this.model.startDate, AppSettings.YYYY_MM_DD),
      "endDate": this.helper.convert(this.model.endDate, AppSettings.YYYY_MM_DD),
      "isPaidLicense": this.model.licenseType == "paid",
      "scriptless": this.model.scriptlesscheck,
      "randomTDG": this.model.randomTestDataCheck,
      "scripted": this.model.scriptedcheck,
      "designCopilot": this.model.designCoPilotCheck,
      "utilities": this.utilityRightList,
      "totalCost": this.model.totalCost,
      "instanceType": this.instanceType 
    };
    
    if(this.initialData?.isEdit) {
      this.callEditLicense(data);
    } else {
      this.callCreateLicense(data);
    }
  }
  callCreateLicense(data: any) { 
    this.licensingService.createLicense({
      data: data,
      success: (response: any) => {
        if(response && response.data) {
          console.log(response.data);
        }
        this.helper.showLoader(false);
        this.updateList.emit();
        this.notificationService.showSuccess(response.message);
        this.modalRef.hide();
      },
      error: (error: any) => {
        console.log(error);
        this.helper.showLoader(false);
      }
    });
  }
  callEditLicense(data: any) {
    if(this.initialData.isEdit) {
      data.isActive = this.model.isActive;
    }
    this.licensingService.editLicense({
      data: data,
      success: (response: any) => {
        if(response && response.data) {
          console.log(response.data);
        }
        this.helper.showLoader(false);
        this.updateList.emit();
        this.notificationService.showSuccess(response.message);
        this.modalRef.hide();
      },
      error: (error: any) => {
        console.log(error);
        this.helper.showLoader(false);

      }
    });
  }
  convert(str:any) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  setCost() {
    if(this.model.licenseType?.toLowerCase() == "trial") {
      this.model.totalCost = 0;
      return;
    }
    this.model.totalCost = this.helper.calculateCost(this.modulesTobeCharged, this.priceList, this.model.userCount);
  }
  onLicenseTypeChange(e: any) {
    if(this.model.licenseType?.toLowerCase() == "trial") {
      this.model.userCount = 10;
    }
    this.setCost();
  }
  onStartDateChange(e: any) {
    if(this.model.licenseType?.toLowerCase() == "trial" && this.model.startDate && !this.model.isEdit) {
      this.model.endDate = new Date(this.model.startDate.setMonth(this.model.startDate.getMonth() + 1));
    }
  }
}
